export enum Panel {
  Alternating = "alternating",
  Solid = "solid"
}

export enum AlternatingPanel {
  Two = 'alt-2',
  Four = 'alt-4'
}

export enum Valance {
  Canopy = "none",
  Standard = "standard",
  Whale = "whale",
  ClassicScallop = "scallop",
  ClassicScallopShort = "scallop-short",
  French = "french",
  Roman = "roman",
  WaveScallop = "wave-scallop",
  WaveScallopShort = "wave-scallop-short",
  // Trojan = "trojan",
}

export enum Rib {
  Pockets = "pocket",
  Grommets = "grommet"
}

export enum BottomPole {
  Standard = "standard",
  Bar = "bar"
}

export enum Finial {
  Ball = "ball",
  Vertex = "vertex"
}

export enum FinialFinishType {
  TPU = "tpu",
  CH = "chrome",
  SS = "stainless steel"
}

export enum Spigot {
  Standard = "standard",
  StainlessSteel = "stainless steel"
}

export enum Preset {
  S1 = "S1",
  S1DV = "S1DV",
  D1 = "D1",
  D2 = "D2",
  D3 = "D3",
  D4 = "D4",
  D5 = "D5"
}

export enum Stem {
  Stem8ST = "8ST",
  Stem18ST = "18ST",
  Stem18ST2 = "18ST2"
}

export enum StemDisplayName {
  Stem8ST = '8" Stem',
  Stem18ST = '18" Stem',
  Stem18ST2 = '18" Stem'
}

export enum FringeColors {
  OneColor = "one color",
  TwoColor = "two color",
  ThreeColor = "three color",
  None = "none"
}

export enum Fringe {
  None = "none",
  Brush = '1" brush',
  Bullion3 = '3" bullion',
  Bullion5 = '5" bullion'
}
